export default __webpack_public_path__ + "static/media/fried.d7d55fa2.png";